import React from "react"
import { useState } from "react"
import AsyncSelect from "react-select/async"
import DatePicker from "react-datepicker"
import { Col } from "reactstrap"
import { getAuthorizationToken } from "helpers/storagehelper"
import { useEffect } from "react"
import { customStylesSelect } from "../../../common/data/settings"

const ActivityLogFilter = ({
  handleChange,
  authUser,
  formData,
}) => {
  const [allUsers, setAllUser] = useState([])

  useEffect(() => {
    getUserListData(authUser.data?.firstname.substr(0, 3), () => {}, undefined)
  }, [])

  const getUserListData = async (
    searchValue,
    callback,
    searchKey = "useremail"
  ) => {
    try {
      const data = await fetch(
        `${process.env.REACT_APP_API_URL}/Users/GetUsers`,
        {
          method: "post",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchKey,
            searchValue,
            pageNumber: 0,
            pageSize: 20,
          }),
        }
      )
        .then(res => res.json())
        .then(res => {
          setAllUser(res.data)
          return res.data.map(el => ({
            ...el,
            label: el.username,
            value: el.id,
          }))
        })
      callback(data)
      return data
    } catch (err) {
      console.log(err, "err")
      return []
    }
  }

  const loadOptions = (inputValue, callback) => {
    getUserListData(inputValue, callback)
  }

  const selectedUser = allUsers.filter(el => el.id === formData.userId)[0]

  return (
    <Col sm="12" className="d-flex justify-content-end mobile_work_filter">
      <div className="w-100 mb-4">
        <div className="d-flex mobile_responsive_filter timelog-customize-header">
          <div className="mx-2 timlog-date">
            <DatePicker
              dateFormat="yyyy-MM-dd"
              selected={new Date(formData.date)}
              onChange={value => handleChange(value, "date")}
              className="form-control mb-0 date-icon-back"
              placeholderText="Select date"
              maxDate={new Date()}
            />
          </div>
          {authUser.data.accessgroupname !== "User" &&
            authUser.data.accessgroupname !== "Supervisor" && (
              <div className="mx-2 w-25 timelog-select">
                <AsyncSelect
                  styles={customStylesSelect}
                  value={{
                    ...selectedUser,
                    label: selectedUser?.username,
                    value: selectedUser?.id,
                  }}
                  onChange={value => handleChange(value, "userId")}
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions={(allUsers || [])?.map(el => ({
                    ...el,
                    label: el.username,
                    value: el.id,
                  }))}
                  classNamePrefix="select2-selection"
                  className="add_Zindex_one "
                />
              </div>
            )}
        </div>
      </div>
    </Col>
  )
}

export default ActivityLogFilter
